import { metricCardContainer as containerClasses } from '../metric-card-styles';
import type { AssetCountStatus } from './types';

/**
 * Asset-count number color: green when within the optimal range (`success`),
 * orange when outside it. Disabled drops to the shared disabled gray.
 */
function getAssetCountColor(status: AssetCountStatus, isDisabled: boolean): string {
  if (isDisabled) return 'text-fg-disabled-subtle';
  return status === 'success' ? 'text-fg-success-secondary' : 'text-orange-500';
}

export { containerClasses, getAssetCountColor };
